import type { LightingAdvisorAccessoryConfiguration } from '~/utils/lightingAdvisor/configurationSchema';

export interface ResolvedLightingAdvisorAccessoryConfiguration {
  slpControllerSku: string;
  twoChannelControllerSku: string;
  fourChannelControllerSku: string;
  controllerConnectCableSku: string;
  powerCordSkus: string[];
  blacklist: string[];
}

export const DEFAULT_LIGHTING_ADVISOR_ACCESSORY_CONFIGURATION: ResolvedLightingAdvisorAccessoryConfiguration =
  {
    slpControllerSku: '2200000258',
    twoChannelControllerSku: '2200001188',
    fourChannelControllerSku: '2200001189',
    controllerConnectCableSku: '2200001192',
    powerCordSkus: [
      '2200001195',
      '2200001196',
      '2200001197',
      '2200001198',
      '2200001199'
    ],
    blacklist: ['dongle', '3d software', 'pylon vtool']
  };

export function resolveLightingAdvisorAccessoryConfiguration(
  configuration?: LightingAdvisorAccessoryConfiguration
): ResolvedLightingAdvisorAccessoryConfiguration {
  return {
    ...DEFAULT_LIGHTING_ADVISOR_ACCESSORY_CONFIGURATION,
    ...configuration,
    powerCordSkus:
      configuration?.powerCordSkus ??
      DEFAULT_LIGHTING_ADVISOR_ACCESSORY_CONFIGURATION.powerCordSkus,
    blacklist:
      configuration?.blacklist ??
      DEFAULT_LIGHTING_ADVISOR_ACCESSORY_CONFIGURATION.blacklist
  };
}
